import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { Checkbox } from '@fluentui/react/lib/Checkbox';
import type { SearchFilterOption } from 'owa-timestream-asset-search';
import useCheckboxSearchRefinerState from '../../hooks/useCheckboxSearchRefinerState';

export default observer(function CheckboxSearchRefiner({ option }: { option: SearchFilterOption }) {
    const { onChange } = useCheckboxSearchRefinerState({ option });

    if (option.type !== 'Checkbox') {
        return null;
    }

    return (
        <div className={styles.checkboxWrapper}>
            <span className={styles.label}>{option.label}</span>
            <Checkbox
                className={styles.checkbox}
                checked={!!option.value}
                onChange={onChange}
                ariaLabel={option.label}
                styles={{ checkbox: { width: 14, height: 14 } }}
            />
        </div>
    );
});
